// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasks-counter[data-v-786c7d84]{display:flex;align-items:center;margin-inline:calc(var(--default-grid-baseline)*2)}.tasks-counter__count[data-v-786c7d84]{font-weight:500}`, "",{"version":3,"sources":["webpack://./src/components/TopBar/TasksCounter.vue"],"names":[],"mappings":"AACA,gCACC,YAAA,CACA,kBAAA,CACA,kDAAA,CAEA,uCACC,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
